module.exports = __webpack_public_path__ + "static/cover-spring-summer-2023-91954a8ac3260a9904c662c20ead58dd.jpg";